import React, { Component } from "react";
import ReactGA from 'react-ga';
import Link from "react-router-dom/Link";
import Page from "../Page";
import restartSVG from "img/restart.svg";
import cage from "img/cage1.png";
import bang from "img/bang.png";

import Popup3 from "../popup/Popup3";

export default class Problem extends Component {
  constructor(props) {
    super(props);
    this.state = { showPopup: false };
  }

  showPopup = () => {
    this.setState({ showPopup: true });
  };

  render() {
    const { showPopup } = this.state;
    const {
      storeNumber,
      BOPIS_Cancel_Retail,
      Extend_Cancel_Retail,
      resetData
    } = this.props;

    ReactGA.pageview('/problem/3')

    return (
      <Page>
        <div className="problem-page">
          <div className="introduction-page__restart-block">
            <ul className="arrival-page__arms-list">
              <li className="in-red">A</li>
              <li className="in-red">R</li>
              <li>M</li>
              <li className="in-red">S</li>
            </ul>
            <Link
              to={{ pathname: "/login", state: { prev: true } }}
              className="introduction-page__restart-btn"
              href="#"
              onClick={resetData}
            >
              <img
                className="introduction-page__restart-icon"
                src={restartSVG}
                alt=""
              />
              <span>Restart</span>
            </Link>
          </div>
          <div className="problem-page__main-section">
            <div className="problem-page__investigate-block">
              <div className="problem-page__animated-block">
                <img className="problem-page__bang-circle" src={bang} alt="" />
                <h1 className="problem-page__header-text">Item is Out of Stock!</h1>
                <p>
                  The department supervisor must check and update on-hands weekly
                  to ensure cage items are in stock and ready for customer
                  purchase.
                </p>
                <Link
                  to="/problem/3"
                  onClick={this.showPopup}
                  className="btn login-page__start-btn"
                >
                  <span>Let's investigate</span>
                </Link>
              </div>
            </div>
            <div className="problem-page__image-container">
              <img className="problem-page__image" src={cage} alt="" />
            </div>
          </div>

          {showPopup && (
            <Popup3
              storeNumber={storeNumber}
              BOPIS_Cancel_Retail={BOPIS_Cancel_Retail}
              Extend_Cancel_Retail={Extend_Cancel_Retail}
            />
          )}
        </div>
      </Page>
    );
  }
}
